export type Device = 'ios' | 'android' | 'desktop';

export function detectDevice(ua: string): Device {
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return 'desktop';
}

export interface Guide {
  title: string;
  /** En kolay yol: sayfayı kopyalayıp yükleme sayfasındaki kutuya yapıştırma. */
  pasteSteps: string[];
  /** Dosya olarak kaydedip seçme. */
  steps: string[];
}

const PASTE_TARGET = 'akrababul yükleme sayfasındaki "Buraya yapıştırın" kutusuna';
/** Seçim menüsündeki "tümünü seç" öğesinin adı; iOS ve Android farklı büyük harf kullanır. */
const SELECT_ALL: Record<Device, string> = { ios: 'Tümünü Seç', android: 'Tümünü seç', desktop: 'Tümünü seç' };
const isTouch = (d: Device): boolean => d !== 'desktop';

/** Yapıştırma kutusunun üstündeki tek cümlelik yönerge. */
export function pasteIntroFor(d: Device): string {
  return isTouch(d)
    ? `e-Devlet sayfasında bir yazıya basılı tutup "${SELECT_ALL[d]}" deyin, "Kopyala" seçin, sonra aşağıdaki kutuya basılı tutup "Yapıştır" deyin. Dosya kaydetmeniz gerekmez.`
    : 'e-Devlet sayfasında her şeyi seçin (Ctrl+A), kopyalayın (Ctrl+C), sonra aşağıdaki kutuya yapıştırın (Ctrl+V). Dosya kaydetmeniz gerekmez.';
}

/** Yapıştırma kutusunun kendi içindeki metin. */
export function pastePlaceholderFor(d: Device): string {
  return isTouch(d) ? 'Buraya basılı tutup "Yapıştır" deyin' : 'Buraya yapıştırın (Ctrl+V)';
}

/**
 * Yapıştırılan belge okunamadığında gösterilen ipucu. Dokunmatik cihazlarda tutamaçları
 * sürükleyerek yapılan kısmi seçim kolay olduğu ve tablonun başlık satırı yarım kalınca
 * belge hiç okunamadığı için dosya yolu da önerilir.
 */
export function pasteHintFor(d: Device): string {
  return isTouch(d)
    ? `Sayfanın tamamını seçtiğinizden emin olun - bir yazıya basılı tutup "${SELECT_ALL[d]}" deyin. Seçim tutmuyorsa sayfayı dosya olarak kaydedip yükleyebilirsiniz.`
    : 'e-Devlet sayfasında her şeyi seçip (Ctrl+A) kopyaladığınızdan (Ctrl+C) emin olun.';
}

export function guideFor(d: Device): Guide {
  switch (d) {
    case 'ios': return { title: 'iPhone / iPad (Safari)', pasteSteps: [
      'Safari ile turkiye.gov.tr\'ye girin, "Alt-Üst Soy Bilgisi Sorgulama" hizmetini açın ve sorgulayın.',
      `Sayfadaki bir yazıya basılı tutun; çıkan menüden "${SELECT_ALL['ios']}" seçin.`,
      'Menüden "Kopyala" seçin.',
      `${PASTE_TARGET} basılı tutup "Yapıştır" seçin.`], steps: [
      'Safari ile turkiye.gov.tr\'ye girin, "Alt-Üst Soy Bilgisi Sorgulama" hizmetini açın ve sorgulayın.',
      'Alttaki Paylaş düğmesine (kare ve yukarı ok) dokunun.',
      'En üstte sayfa başlığının altındaki "Seçenekler" yazısına dokunun, "Web Arşivi" seçin, "Bitti" deyin.',
      '"Dosyalara Kaydet" seçin ve bir klasöre kaydedin.',
      'akrababul\'a dönüp "Dosya seç" ile bu .webarchive dosyasını seçin.'] };
    case 'android': return { title: 'Android (Chrome)', pasteSteps: [
      'Chrome ile turkiye.gov.tr\'ye girin, "Alt-Üst Soy Bilgisi Sorgulama" hizmetini açın ve sorgulayın.',
      `Sayfadaki bir yazıya basılı tutun; çıkan menüden "${SELECT_ALL['android']}" seçin.`,
      'Menüden "Kopyala" seçin.',
      `${PASTE_TARGET} basılı tutup "Yapıştır" seçin.`], steps: [
      'Chrome ile turkiye.gov.tr\'ye girin, "Alt-Üst Soy Bilgisi Sorgulama" hizmetini açın ve sorgulayın.',
      'Sağ üstteki üç nokta menüsüne dokunun.',
      'İndir simgesine (aşağı ok) dokunun; sayfa .mhtml olarak İndirilenler klasörüne kaydedilir.',
      'akrababul\'a dönüp "Dosya seç" ile bu dosyayı İndirilenler\'den seçin.'] };
    default: return { title: 'Bilgisayar (Chrome, Edge, Firefox)', pasteSteps: [
      'turkiye.gov.tr\'ye girin, "Alt-Üst Soy Bilgisi Sorgulama" hizmetini açın ve sorgulayın.',
      'Sayfada boş bir yere tıklayıp Ctrl+A (Mac\'te Cmd+A) ile her şeyi seçin.',
      'Ctrl+C (Mac\'te Cmd+C) ile kopyalayın.',
      `${PASTE_TARGET} tıklayıp Ctrl+V (Mac'te Cmd+V) ile yapıştırın.`], steps: [
      'turkiye.gov.tr\'ye girin, "Alt-Üst Soy Bilgisi Sorgulama" hizmetini açın ve sorgulayın.',
      'Ctrl+S (Mac\'te Cmd+S) tuşlarına basın.',
      '"Kayıt türü" olarak "Web sayfası, tamamı" seçin ve kaydedin. (Safari: "Web Arşivi" de olur.)',
      'akrababul\'a dönüp "Dosya seç" ile kaydettiğiniz .html dosyasını seçin.'] };
  }
}
